<template>
  <v-dialog v-model="value" persistent max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ $t('reports.delivery_report_title') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <div v-if="delivers.length == 0">{{ textNoInfo }}</div>
              <div div class="chart-container" style="height: 35vh">
                <canvas
                  id="canvaStdByDelivers"
                  style="width: 100%; height: 100%"
                ></canvas>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" flat>
          {{ $t('generic.close') }}
        </v-btn>
        <v-btn @click="download" v-if="dButton" color="primary" flat>
          {{ $t('generic.download') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Chart from 'chart.js'
import jsPDF from 'jspdf'
import { required, sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'body'],
  validations: {
    passwordForm: {
      currentPassword: { required },
      newPassword: { required },
      confirmPassword: { required, sameAsPassword: sameAs('newPassword') },
    },
  },
  data: () => ({
    passwordForm: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    delivers: [],
    data: {},
    deliverChar: null,
    textNoInfo: '',
    dButton: false,
  }),
  watch: {
    value() {
      let vm = this
      if (vm.value && vm.body) {
        vm.$store
          .dispatch('reports/getDelivers', vm.body)
          .then((response) => {
            vm.delivers = response.data.entity

            if (vm.deliverChar == null) {
              let ctx = document
                .getElementById('canvaStdByDelivers')
                .getContext('2d')
              ctx.clearRect(
                0,
                0,
                ctx.canvas.width + 100,
                ctx.canvas.height + 100
              )
              ctx.webkitImageSmoothingEnabled = false
              ctx.mozImageSmoothingEnabled = false
              ctx.imageSmoothingEnabled = false
              vm.deliverChar = new Chart(ctx, {
                type: 'bar',
                data: vm.charDataDeliver,
                options: {
                  legend: {
                    display: false,
                  },
                  responsive: true,
                  tooltips: {
                    callbacks: {
                      label: function (tooltipItem, data) {
                        return data.labels[tooltipItem.index]
                      },
                    },
                  },
                  scales: {
                    yAxes: [
                      {
                        display: true,
                        ticks: {
                          beginAtZero: true,
                        },
                      },
                    ],
                  },
                },
              })

              vm.dButton = vm.delivers.length == 0 ? false : true
            } else {
              if (vm.delivers.length == 0) {
                vm.textNoInfo = 'No hay entregas en este periodo'
                vm.deliverChar.data.labels = new Array()
                vm.deliverChar.data.datasets = new Array()
                vm.dButton = false
                vm.deliverChar.update()
              } else {
                let charDataDeliver = vm.charDataDeliver
                vm.deliverChar.data.labels = charDataDeliver.labels
                vm.deliverChar.data.datasets = charDataDeliver.datasets
                vm.dButton = true
                vm.deliverChar.update()
              }
            }
          })
          .catch((error) => {
            vm.toast.failed = true
            console.log(error)
          })
      }
    },
  },
  methods: {
    close() {
      this.textNoInfo = ''
      this.delivers = []
      this.data = {}
      this.dButton = false
      this.$emit('input', !this.value)
    },
    download() {
      var canvas = document.getElementById('canvaStdByDelivers')
      //creates image
      var canvasImg = canvas.toDataURL('image/png')
      var type = 'Reporte de entregas'
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      var headers = []
      var bodyTable = []
      let doc = new jsPDF('landscape')
      let branch = this.getBranch
      let fDate =
        this.body.dayB +
        '-' +
        this.body.monthB +
        '-' +
        this.body.yearB +
        ' al ' +
        this.body.dayE +
        '-' +
        this.body.monthE +
        '-' +
        this.body.yearE
      var pdfName = type
      var header = function (data) {
        // doc.setFont("helvetica");
        // doc.setFontType("bold");
        // doc.setFontSize(25);
        doc.text('Colegio ' + branch.name, 55, 15)
        // doc.setFont("helvetica");
        // doc.setFontSize(13);
        // doc.text(type, 55, 25);
        doc.text('Periodo: ' + fDate, 55, 35)
        var splitTitle = doc.splitTextToSize(branch.address, 400)
        var y = 45
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 55, y)
          y += 5
        }
        var img = new Image()

        if (branch.img != null && branch.img != '') {
          var imgData =
            branch.img == null ? '' : 'data:image/png;base64, ' + branch.img
          img.onload = function () {
            doc.addImage(imgData, 'PNG', data.settings.margin.left, 10, 30, 30) //(imagen,formato,x-pos,y-pos, width,heigth)
          }
        }
        var width = doc.internal.pageSize.getWidth()
        var widthNoMargins = width - data.settings.margin.left
        var pos = (widthNoMargins - 170) / 2
        doc.addImage(
          canvasImg,
          'PNG',
          pos,
          60,
          canvas.width / 3,
          canvas.height / 3
        )
      }
      doc.autoTable({
        head: [headers],
        margin: {
          top: 120,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: 'grid',
        },
        columnStyles: {
          0: {
            fontSize: 15,
          },
        },
        didDrawPage: header,
      })

      doc
        .save(type + '.pdf', { returnPromise: true })
        .then((res) => {
          console.log(res)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((err) => {
          console.log(err)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },
  },
  computed: {
    ...mapGetters(['getBranch']),
    charDataDeliver: function () {
      let vm = this
      let dataInDataset = []
      let labels = []
      for (const [index, item] of vm.delivers.entries()) {
        dataInDataset.push(item.num)
        if (item.typeDeliver) {
          switch (item.typeDeliver.id) {
            case 1:
              labels.push('Marcha del tutor' + ': ' + item.num)
              break
            case 2:
              labels.push('No respuesta del tutor' + ': ' + item.num)
              break
            case 3:
              labels.push(
                this.$t('reports.delivery_report.tutor_confirmation') +
                  ': ' +
                  item.num
              )
              break
            case 4:
              labels.push(
                this.$t('reports.delivery_report.delivered_from_staff') +
                  ': ' +
                  item.num
              )
              break
            case 5:
              labels.push(
                this.$t('reports.delivery_report.check_out') + ': ' + item.num
              )
              break
          }
        } else {
          labels.push('Desconocido: ' + item.num)
        }
      }
      return {
        datasets: [
          {
            data: dataInDataset,
            backgroundColor: [
              'rgb(34,204,0)',
              'rgb(0,153,230)',
              'rgb(255,25,25)',
              'rgb(64,0,128)',
              'rgb(204,204,0)',
            ],
          },
        ],
        labels: labels,
      }
    },
  },
}
</script>

<style></style>
